import { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const translations = {
  ba: null,
  en: null,
  fr: null,
  es: null,
  it: null,
  ru: null,
  ar: null,
  de: null
};

export const useTranslation = () => {
  const { currentLanguage } = useLanguage();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadTranslations = async () => {
      setIsLoading(true);

      if (!translations.ba) {
        const fallbackModule = await import('../translations/ba.json');
        translations.ba = fallbackModule.default;
      }

      if (!translations[currentLanguage]) {
        try {
          const translationModule = await import(`../translations/${currentLanguage}.json`);
          translations[currentLanguage] = translationModule.default;
        } catch (error) {
          console.error(`Failed to load translations for ${currentLanguage}:`, error);
        }
      }

      setIsLoading(false);
    };

    loadTranslations();
  }, [currentLanguage]);

  const getTranslationValue = (source, keys) => {
    let value = source;

    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        return null;
      }
    }

    return value;
  };

  const t = (key, fallback = '') => {
    const keys = key.split('.');
    const value = translations[currentLanguage] ? getTranslationValue(translations[currentLanguage], keys) : null;

    if (value) {
      return value;
    }

    const fallbackValue = translations.ba ? getTranslationValue(translations.ba, keys) : null;
    return fallbackValue || fallback || key;
  };

  return { t, isLoading, currentLanguage };
};
